// Axios
import axios from 'axios'

export const getPlaceDetailApi = (placeId) => new Promise((resolve, reject) => {
  axios.get(
    `https://places.googleapis.com/v1/places/${placeId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        'X-Goog-FieldMask': 'id,displayName,location,formattedAddress,addressComponents'
      }
    }
  )
    .then(resolve)
    .catch(reject)
})

export const getPlaceDetail = async function (placeId) {
  try {
    const res = await getPlaceDetailApi(placeId)
    const loc = res.data.location

    if (!loc || loc.latitude === undefined || loc.longitude === undefined) {
      return null
    }

    return loc
  } catch (error) {
    return null
  }
}
